import {WidgetType} from '@codemirror/view'
import {clsx} from 'clsx'

import sharedStyles from '../extensions/decorate-markdown.module.css'
import styles from './thematic-break.module.css'

export const ThematicBreakWidget = new (class extends WidgetType {
  toDOM() {
    const container = document.createElement('div')
    container.className = clsx(sharedStyles.block, styles.container)
    const hr = document.createElement('hr')
    hr.className = clsx(styles.thematicBreak)
    container.appendChild(hr)
    return container
  }

  override eq() {
    return true
  }

  override ignoreEvent() {
    return false
  }
})()
